export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-female-3a43391cc585fab951eadbd88746e19a.svg";